import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ErrorView from '../../components/ErrorView'
import LoadingScreen from '../../components/LoadingScreen'
import ShowEffectiveVisitView from './ShowNoEffectiveVisitView'

const ShowNoEffectiveVisitApp = () => {
  const { id } = useParams()

  const [isFetching, setIsFetching] = useState(true)
  const [error, setError] = useState(null)
  const [details, setDetails] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)

  useEffect(() => {
    let isMounted = true
    setIsFetching(true)
    setError(null)

    authFetch(`${BASE_BACKEND_URL}/no_effective_visits/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return null
        if (response.status === 404) {
          return {
            error: true,
            message: 'No se encontró la visita no efectiva'
          }
        }
        return response.json()
      })
      .then((data) => {
        if (!isMounted || data == null) return
        if (data.error) {
          setError(data.message)
        } else {
          setDetails(data)
          setDefaultDetails(data)
        }
      })
      .catch(() => {
        if (isMounted) setError('Error de red o servidor')
      })
      .finally(() => {
        if (isMounted) setIsFetching(false)
      })

    return () => {
      isMounted = false
    }
  }, [id])

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  if (error) {
    return <ErrorView error={error} />
  }

  return (
    <ShowEffectiveVisitView
      details={details}
      position={id}
      defaultDetails={defaultDetails}
    />
  )
}

export default ShowNoEffectiveVisitApp
